<p-dialog
  header="Dosya Yükleme"
  [(visible)]="displayUploadDialog"
  [modal]="true"
  [closable]="false"
  [style]="{ width: '35rem', 'max-height': '60vh', 'overflow-y': 'auto' }"
>
  <div class="modal-body">
    <form (ngSubmit)="save()" #fileUploadForm="ngForm">
      <div class="row mb-3">
        <div class="col-12">
          <input
            #fileInput
            type="file"
            (change)="onFileChange($event)"
            class="form-control"
            name="file"
            required
          />
          <div *ngIf="fileError" class="text-danger mt-2">{{ fileError }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <label class="form-label" for="">
            {{ "announcement.file-description" | translate }}
          </label>
          <input
            #selectedFileDesc
            type="text"
            class="form-control"
            [placeholder]="'file.description-placeholder' | translate"
            [(ngModel)]="fileDescription"
            name="fileDescription"
            required
          />
        </div>
      </div>
    </form>
  </div>
  <ng-template pTemplate="footer">
    <button
      type="button"
      class="btn btn-danger"
      style="margin-right: 3%"
      (click)="cancelDialog()"
    >
      {{ "common.cancel" | translate }}
    </button>
    <button type="button" class="btn btn-success" (click)="save()">
      {{ "common.save" | translate }}
    </button>
  </ng-template>
</p-dialog>
